function view (path) {
  return () => import(/* webpackChunkName: 'wo-v1' */ '@/views/user/wo/' + path).then(m => m.default || m) // eslint-disable-line prefer-template
}

function viewPurchaseOrders (path) {
  return view('purchase-orders/' + path)
}

function viewInterWarehouses (path) {
  return view('inter-warehouses/' + path)
}

function viewAuthorityToWithdraws (path) {
  return view('atws/' + path)
}

const RWarehouseOfficer = [
  {
    path: '/warehouse/dashboard',
    component: view('Dashboard'),
    name: 'wo.dashboard',
    authorizedRole: 'user'
  }
]

const RWOPurchaseOrders = [
  {
    path: '/warehouse/purchase-orders/requests/:requester?/:status?',
    component: viewPurchaseOrders('requests/Base'),
    name: 'wo.purchase-orders.requests',
    authorizedRole: 'user',
    meta: {
      breadcrumb: [
        {
          text: 'Warehouse'
        },
        {
          text: 'Purchase Orders'
        },
        {
          text: 'Requests',
          active: true
        }
      ]
    }
  },
  {
    path: '/warehouse/purchase-orders/approvals/:approver?/:status?',
    component: viewPurchaseOrders('approvals/Base'),
    name: 'wo.purchase-orders.approvals',
    authorizedRole: 'user',
    meta: {
      breadcrumb: [
        {
          text: 'Warehouse'
        },
        {
          text: 'Purchase Orders'
        },
        {
          text: 'Approvals',
          active: true
        }
      ]
    }
  },
  {
    path: '/warehouse/purchase-orders/posting/:poster?/:status?',
    component: viewPurchaseOrders('posting/Base'),
    name: 'wo.purchase-orders.posting',
    authorizedRole: 'user',
    meta: {
      breadcrumb: [
        {
          text: 'Warehouse'
        },
        {
          text: 'Purchase Orders'
        },
        {
          text: 'Posting',
          active: true
        }
      ]
    }
  },
  {
    path: '/warehouse/purchase-orders/receiving/:receiver?/:status?',
    component: viewPurchaseOrders('receiving/Base'),
    name: 'wo.purchase-orders.receiving',
    authorizedRole: 'user',
    meta: {
      breadcrumb: [
        {
          text: 'Warehouse'
        },
        {
          text: 'Purchase Orders'
        },
        {
          text: 'Receiving',
          active: true
        }
      ]
    }
  }
]

const RWOAuthorityToWithdraws = [
  {
    path: '/warehouse/atws/receiving/:receiver?/:status?',
    component: viewAuthorityToWithdraws('receiving/Base'),
    name: 'wo.atws.receiving',
    authorizedRole: 'user',
    meta: {
      breadcrumb: [
        {
          text: 'Warehouse'
        },
        {
          text: 'Authority To Withdraws'
        },
        {
          text: 'Receiving',
          active: true
        }
      ]
    }
  }
]

const RWOInterWarehouses = [
  {
    path: '/warehouse/inter-warehouses/transfers/:transfer?/:status?',
    component: viewInterWarehouses('transfers/Base'),
    name: 'wo.inter-warehouses.transfers',
    authorizedRole: 'user',
    meta: {
      breadcrumb: [
        {
          text: 'Warehouse'
        },
        {
          text: 'Inter Warehouses'
        },
        {
          text: 'Transfers',
          active: true
        }
      ]
    }
  },
  {
    path: '/warehouse/inter-warehouses/posting/:poster?/:status?',
    component: viewInterWarehouses('posting/Base'),
    name: 'wo.inter-warehouses.posting',
    authorizedRole: 'user',
    meta: {
      breadcrumb: [
        {
          text: 'Warehouse'
        },
        {
          text: 'Inter Warehouses'
        },
        {
          text: 'Posting',
          active: true
        }
      ]
    }
  },
  {
    path: '/warehouse/inter-warehouses/receiving/:receiver?/:status?',
    component: viewInterWarehouses('receiving/Base'),
    name: 'wo.inter-warehouses.receiving',
    authorizedRole: 'user',
    meta: {
      breadcrumb: [
        {
          text: 'Warehouse'
        },
        {
          text: 'Inter Warehouses'
        },
        {
          text: 'Receiving',
          active: true
        }
      ]
    }
  }
]

export default RWarehouseOfficer.concat(
  RWOPurchaseOrders,
  RWOAuthorityToWithdraws,
  RWOInterWarehouses
)
